import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import AmenityCardList from './CardLists/AmenityCardList';
import BackArrowIcon from '@material-ui/icons/ArrowBackIosOutlined';

import { getResidentAmenityBookings } from './store/actions';
import { DEFAULT } from './TenantActivity';

const ActivityTitle = styled.div`
  font-size: 24px;
  color: ${colors.FONT_DARK_GREY};
  padding-bottom: 20px;
  margin: 0;
  display: flex;
  align-items: center;
`;

const StyledBackButton = styled.button`
  color: ${colors.ULTRAMARINE_BLUE};
  cursor: pointer;
  background: none;
  border: none;
  padding: 6px 0px 0px;
  text-align: left;
  margin-right: 15px;
`;

const AllAmenitiesList = ({
  cotenantId,
  amenityBookings,
  totalAmenityBookings,
  getResidentAmenityBookings,
  setView,
}) => {
  const handleBackArrow = () => {
    getResidentAmenityBookings(cotenantId);
    setView(DEFAULT);
  };

  return (
    <Fragment>
      <ActivityTitle>
        <StyledBackButton>
          <BackArrowIcon onClick={() => handleBackArrow()} />
        </StyledBackButton>
        {getTranslatedString('landlordPortal.tenantDetails.activity.amenityBookings', {
          totalAmenityBookings: totalAmenityBookings,
        })}
      </ActivityTitle>
      <AmenityCardList amenityBookings={amenityBookings} />
    </Fragment>
  );
};

const mapStoreToProps = store => ({
  cotenantId: store.landlordTenants.tenantDetails.id,
  amenityBookings: store.landlord.tenants.tenantActivity.amenityBookings,
  totalAmenityBookings: store.landlord.tenants.tenantActivity.totalAmenityBookings,
});

const mapDispatchToProps = {
  getResidentAmenityBookings,
};

export default connect(mapStoreToProps, mapDispatchToProps)(AllAmenitiesList);
